import React, { Component } from "react";
import { connect } from 'react-redux';
import classes from './RoundTupleInner.scss';

import AgencySummary from '../../AgencySummary/AgencySummary';

import Media from 'react-media';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AirlineLogo from '../../Airline/AirlineLogo/AirlineLogo';

import Tooltip from '../../../UI/Tooltip/Tootip';

import moment from 'moment';

import Deal from '../../../UI/Deal/Deal';

class RoundTripInner extends Component {
  state = {
    isAgencyFareSummaryVisible: false
  }

  openAgencyFareSummary = () => this.setState({ isAgencyFareSummaryVisible: true })
  closeAgencyFareSummary = () => this.setState({ isAgencyFareSummaryVisible: false })

  render() {
    let containerClasses = [classes.Container];

    if (this.props.index === this.props.activeIndex) {
      containerClasses.push(classes.ContainerActive);
    }

    const OD = this.props.flightSchedule[0];
    const FS = this.props.flightSchedule[0].FS;
    const TF = this.props.fareDetails.revisedFareDetails.tf;
    const airlines = this.props.airlineNames;
    // Checking Stop / Non Stop
    let totalStop = null;
    let stop0 = null;
    let stop1 = null;
    let stop2 = null;
    let stopCity0 = null;
    let stopCity1 = null;
    let stopCity2 = null;
    let stopOver = null;
    let allStopovers = [];
    let so0 = null;
    let so1 = null;
    let so2 = null;
    let so3 = null;

  if(FS.length === 1) {
      totalStop = 0;
      if(FS[0].so) {
          so0 = FS[0].so;
      }
  }
  if(FS.length > 1) {
      totalStop = FS.length - 1;
      if(FS.length === 2) {
          if(FS[0].so) {
              so0 = FS[0].so;
              allStopovers.push(so0);
          }
          if(allStopovers.length === 1) {
              stop0 = ","
          } else {
              stop0 = "Via"
          }
          stopCity0 = FS[0].aac;
          allStopovers.push(
              <span className={classes.Stopover}>
                  {stop0} <Tooltip type="stopCity" aria-label={this.props.cityNames[stopCity0]}>{stopCity0}</Tooltip>
              </span>
          );
          if(FS[1].so) {
              so1 = FS[1].so.split(' ')[1];
              allStopovers.push(so1);
          }
      }
      if(FS.length === 3) {
          if(FS[0].so) {
              so0 = FS[0].so;
              allStopovers.push(so0);
          }
          if(allStopovers.length === 1) {
              stop0 = ",";
          } else {
              stop0 = "Via"
          }
          stopCity0 = FS[0].aac;
          allStopovers.push(
              <span className={classes.Stopover}>
                  {stop0} <Tooltip type="stopCity" aria-label={this.props.cityNames[stopCity0]}>{stopCity0}</Tooltip>
              </span>
          );
          if(FS[1].so) {
              so1 = FS[1].so.split(' ')[1];
              allStopovers.push(so1);
          }
          if(allStopovers.length > 0) {
              stop1 = ",";
          } else {
              stop1 = "Via";
          }
          stopCity1 = FS[1].aac;
          allStopovers.push(
              <span className={classes.Stopover}>
                  {stop1} <Tooltip type="stopCity" aria-label={this.props.cityNames[stopCity1]}>{stopCity1}</Tooltip>
              </span>
          );
          if(FS[2].so) {
              so2 = FS[2].so.split(' ')[1];
              allStopovers.push(so2);
          }
      }
  }

    if (totalStop === 0) {
      if(so0) {
          stop0 = so0;
      } else {
          stop0 = "Non Stop";
      }
      stopOver = <span className={classes.Stopover}>{stop0}</span>;
    } else if (totalStop >= 1) {
      stopOver = allStopovers;
    }

    // Check of arrival and departure dates
    let arrivalDate = null;
    if(!moment(FS[0].ddt).isSame(FS[FS.length - 1].adt)) {
      arrivalDate = moment(FS[FS.length - 1].adt).format("DD MMM");
    }

    let airline = null;
    // Airline Type
    airline = typeof(airlines) !== "undefined" ? airlines[FS[0].ac]: "";

    const airlineCode = FS[0].ac;
    let flightNumber = FS[0].fl;
    let flightCode = FS[0].ac;
    let travelClass = FS[0].travelclass;
    for(let i = 1; i < FS.length; i++) {
        flightNumber += `/ ${FS[i].fl}`;
    }

    return (
      <div
        className={containerClasses.join(' ')}
        style={{ animationDelay: `${this.props.index * 0.325}s` }}
        onClick={() =>
          this.props.clicked(this.props.flightId, this.props.index)
        }
      >
        <div
          className={classes.RightTick}
          style={{
            opacity: this.props.index === this.props.activeIndex ? "1" : "0"
          }}
        >
          <FontAwesomeIcon icon="check-circle" color="#3E72F7" size="1x" />
        </div>
        <div className={`u-flex f-row u-width100Percent u-height80Percent`}>
          <div className={classes.ContainerPrimary}>
              <div className={classes.Image}>
                <AirlineLogo airlineCode={airlineCode} />
              </div>
          </div>
          <div className={classes.ContainerSecondary}>
            <div className={`${classes.Box1} u-flex`}>
                  <div className={classes.Timings}>
                    <span>{FS[0].dd}</span>
                    <span className={classes.Line}></span>
                    <span>{FS[FS.length - 1].ad} {arrivalDate !== null ? <span className={`${classes.ArrivalDate} u-textColorRed`}>{arrivalDate}</span> : null}</span>
                  </div>
                  <div className={classes.Duration}>
                    <span>{OD.tdu.substring(0, 2) + "h " + OD.tdu.substring(3, 5) + "m"}</span>
                  </div>
                  <Media query="(min-width: 599px)">
                    {matches => 
                      matches ? <div className={classes.Price}
                      >
                        {this.state.isAgencyFareSummaryVisible ? <AgencySummary fareDetails={this.props.fareDetails}/> : null}
                        <span
                          onMouseLeave={() => this.closeAgencyFareSummary()}
                          onMouseEnter={() => this.openAgencyFareSummary()}
                          style={{
                            color: this.props.index === 0 ? '#F0BA23' : '#333333'
                          }}
                        >&#8377; {Math.round(parseFloat(TF, 10)).toLocaleString()}</span>
                      </div> : null}
                  </Media>
                  <Media query="(max-width: 599px)">
                      {matches => 
                        matches ? <div className={classes.FlightStop}>
                        {stopOver}
                      </div> : null}
                  </Media>
              </div>
              <div className={`${classes.Box2} u-flex`}>
                  <div className={classes.Flight}>
                    <span>{airline} </span>
                    {window.innerWidth < 600 ? null : <span>
                      {flightCode}-{flightNumber}{`(${travelClass})`}
                    </span>}
                  </div>
                  <Media query="(min-width: 600px)">
                      {matches =>
                        matches ? <div className={classes.FlightStop}>
                        {stopOver}
                      </div> : null}
                  </Media>
                  <Media query="(max-width: 599px)">
                    {matches => 
                      matches ? <div className={classes.Price}
                      >
                        <span
                          style={{
                            color: this.props.index === 0 ? '#F0BA23' : '#4570F5',
                            fontSize: '1.3rem'
                          }}
                        >&#8377; {Math.round(parseFloat(TF, 10)).toLocaleString()}</span>
                      </div> : null}
                  </Media>
                  {
                    this.props.showAgentProfit ? <div className={`${classes.RefundStatus} u-phoneHide`}>
                      {this.props.showAgentProfit ? <p><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.commision).toLocaleString()}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.nf).toLocaleString()}</span></p> : null}
                    </div> : null
                  }
              </div>
          </div>
        </div>
        {
                    this.props.showAgentProfit ? <div className={`${classes.RefundStatus} u-phoneShow`}>
                      {this.props.showAgentProfit ? <p><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.commision).toLocaleString()}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.nf).toLocaleString()}</span></p> : null}
                    </div> : null
                  }
        <div className={`u-flex u-absolute align-items-center u-lineHeight1 u-width90Percent u-bottom6 u-noWrapWithEllipsis justify-content-between`}>
          {this.props.fareDetails.revisedFareDetails.description !== '' ? <div className={`u-flex align-items-center mr-1 u-fontSize11 u-lineHeight1 u-textColorLight u-phone-width100Percent`}>
            <div className={`mr-2`}><Deal/></div>{this.props.fareDetails.revisedFareDetails.description}</div> : <div>&nbsp;</div>}
            {FS[0].sl === '' || !FS[0].sl || parseInt(FS[0].sl, 10) >= 9 ? null : <div className={`u-textColorRed u-fontSize11`}>{FS[0].sl} {FS[0].sl === '1' ? 'seat left' : 'seats left' }</div>}
        </div>
      </div>
    );
  }
};

const mapStateToProps = state => {
  return {
    showAgentProfit: state.ui.showAgentProfit
  }
}

export default connect(mapStateToProps)(RoundTripInner);



// WEBPACK FOOTER //
// ./src/components/Flight/FlightTupleRoundTrip/RoundTupleInner/RoundTupleInner.js